/**
 * SettlementLayout – Full chrome (header, sidebar, chat) for standalone /frame-* settlement screens.
 * Distinct from `layout/SettlementLayout.tsx`, which is the React Router shell with `<Outlet />`.
 */

import type { ReactNode } from 'react';
import { SettlementProvider } from '../../contexts/SettlementContext';
import SettlementHeader from '../layout/SettlementHeader';
import SettlementSidebar from '../layout/SettlementSidebar';
import FloatingChatButton from './FloatingChatButton';

export interface SettlementLayoutProps {
  children: ReactNode;
  /** Estate scope for SettlementProvider (documents, header name, etc.) */
  estateId: string | null;
  /** IAD phase step id for analytics / data attributes */
  currentPhase: 'iad' | string;
  currentStep: string;
}

export function SettlementLayout({ children, estateId, currentPhase, currentStep }: SettlementLayoutProps) {
  return (
    <SettlementProvider estateId={estateId}>
      <div
        className="min-h-screen bg-white"
        data-settlement-phase={currentPhase}
        data-settlement-step={currentStep}
      >
        <SettlementHeader />
        <SettlementSidebar>
          <div className="w-full max-w-5xl mx-auto px-4 py-8 lg:px-8">{children}</div>
        </SettlementSidebar>
        <FloatingChatButton />
      </div>
    </SettlementProvider>
  );
}
